module.exports = __webpack_public_path__ + "img/A.e415802d.svg";